import loadEnvScripts from './lib/loadScript';
import { deviceReady } from './lib/device';

async function init(rootEl) {
    loadEnvScripts();
    await deviceReady();
    return true;
}

export default init;